// StaticPageLayout.js
import React from "react";
import styles from "./StaticPageLayout.module.css"; // Import the CSS module

const StaticPageLayout = ({ title, children }) => {
  return (
    <div className={styles['static-page-layout']}>
      <h1 className={styles['static-page-title']}>{title}</h1>
      <div className={styles['static-page-content']}>
        {children}
      </div>
    </div>
  );
};

export default StaticPageLayout;
